export default __webpack_public_path__ + "static/media/Torpedo-1.cf05b154.png";